/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {useMutation} from 'react-query'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {Portal} from '../../../../../../../_metronic/partials'
import {ActionConfirmation} from '../../../../../../modules/custom/modals/ActionConfirmation'
import {useQueryResponse} from '../../../core/QueryResponseProvider'
import {Receiver} from '../../../core/_models'
import {deleteReceiver} from '../../../core/_requests'
import {profileApi} from '../../../../../../../_metronic/helpers/custom/api/profileApi'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  receiver: Receiver
}

const ReceiverActionsCell: FC<Props> = ({receiver}) => {
  const intl = useIntl()
  const {refetch} = useQueryResponse()

  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const deleteMutation = useMutation<any, Error>(
    async () => {
      return await deleteReceiver(receiver.id)
    },
    {
      onSuccess: () => {},
      onSettled: () => {
        setDeleteModalOpen(false)
        refetch()
      },
      onError: (error) => {
        console.log(error)
      },
    }
  )
  const setDefaultReceiver = async (id: number) => {
    const response = await profileApi.editProfileOverview({
      default_receiver: id,
    })
    console.log('resp', response)

    if (response) {
      refetch()
    }
  }

  return (
    <div className='d-flex justify-content-center flex-shrink-0'>
      {deleteModalOpen && (
        <Portal
          children={
            <ActionConfirmation
              actionName={intl.formatMessage({id: 'RECEIVERS.PAGE.LIST.DELETE_CONF'})}
              setModalOpen={setDeleteModalOpen}
              handleAction={() => deleteMutation.mutate()}
              id={receiver.id}
              isOpen={deleteModalOpen}
            />
          }
          className='modal-root'
        />
      )}

      {receiver.default === 1 && (
        <OverlayTrigger
          placement='top'
          overlay={
            <Tooltip>
              {intl.formatMessage({
                id: 'RECEIVERS.PAGE.LIST.ACTIONS.DEFAULT',
                defaultMessage: 'Default receiver',
              })}
            </Tooltip>
          }
        >
          <span
            className='btn btn-icon btn-bg-light btn-color-success btn-sm me-1 cursor-default'
          >
            <KTSVG path='/media/icons/duotune/arrows/arr084.svg' className='svg-icon-3' />
          </span>
        </OverlayTrigger>
      )}
      {receiver.default === 0 && receiver.active === 1 && receiver.receiver === 1 && (
        <OverlayTrigger
          placement='top'
          overlay={
            <Tooltip>
              {intl.formatMessage({
                id: 'RECEIVERS.PAGE.LIST.ACTIONS.MAKE_DEFAULT',
                defaultMessage: 'Make a default receiver',
              })}
            </Tooltip>
          }
        >
          <button
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            onClick={() => setDefaultReceiver(+receiver.id)}
          >
            <KTSVG path='/media/icons/duotune/general/gen001.svg' className='svg-icon-3' />
          </button>
        </OverlayTrigger>
      )}
      <Link
        to={receiver.id === 0 ? '/profile/overview' : `/receivers/edit/overview/${receiver.id}`}
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
      </Link>

      {receiver.removable === 1 && (
        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          onClick={() => setDeleteModalOpen(true)}
        >
          <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
        </button>
      )}
    </div>
  )
}

export {ReceiverActionsCell}
